import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollPositionService {
  private positions: Map<string, number> = new Map();

  constructor(@Inject(PLATFORM_ID) private platformId: Object,) {

  }

  savePosition(key: string, position: number) {
    this.positions.set(key, position);
  }

  getPosition(key: string): number | null {
    return this.positions.get(key) || null;
  }

  clearPosition(key: string) {
    this.positions.delete(key);
  }


  saveScrollPosition(type: string, elementId: string): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        const element = document.getElementById(elementId); // Use the ID of the element that determines the scrollable container
        const container = this.getScrollableParent(element!);
        if (container) {
          this.savePosition(type, container.scrollTop);
        }
      } catch (error) {
        // fail silently
      }

    }
  }

  restoreScrollPosition(type: string, elementId: string): void {
    try {
      const position = this.getPosition(type);
      if (position !== null) {
        const element = document.getElementById(elementId);// Same ID as in saveScrollPosition
        const container = this.getScrollableParent(element!);
        if (container) {
          setTimeout(() => container.scrollTop = position, 0);
        }
      }
    } catch (error) {
      // fail silently
    }
  }

  scrollTo(elementId: string, scrollToContainerTop: boolean = false, offset: number = 0): void {
    if (isPlatformBrowser(this.platformId)) {
      const element = document.getElementById(elementId);
      if (element) {
        const container = this.getScrollableParent(element);
        if (container) {
          if (scrollToContainerTop) {
            // Scrolls the container of the element to the top with an offset
            container.scrollTo({ top: 0 });
          } else {
            // Scrolls to the element within its container, adjusted by an offset
            const elementTop = element.offsetTop;
            const scrollToPosition = elementTop - offset;
            container.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
          }
        }
      }
    }
  }


  /**
  * Finds the closest scrollable parent element of a given element.
  * @param element The child element whose scrollable parent is to be found.
  * @returns The closest scrollable parent element.
  */
  private getScrollableParent(element: HTMLElement): HTMLElement | null {
    let current = element.parentElement;
    while (current) {
      const overflowY = window.getComputedStyle(current).overflowY;
      if (overflowY === 'auto' || overflowY === 'scroll') {
        return current;
      }
      current = current.parentElement;
    }
    return document.documentElement; // This defaults to the <html> element if no scrollable parent is found
  }
}